import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";

import {
  Card,
  DatePicker,
  Select,
  Rate,
  Input,
  Form,
  Row,
  Col,
  Typography,
  Tag,
  Button,
  message,
} from "antd";
import dayjs from "dayjs";
import { Table as ResponsiveTable, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
// import productImg from "../../assets/images/icons/Moisturizer.png";
import productName from "../../assets/images/skt-icon/prod.png";
import startDate from "../../assets/images/skt-icon/start-date.png";
import expireDate from "../../assets/images/skt-icon/expire-date.png";
import status from "../../assets/images/skt-icon/status.png";
import Rating from "../../assets/images/skt-icon/rating.png";
import buyAgain from "../../assets/images/skt-icon/buy-again.png";
import notes from "../../assets/images/skt-icon/notes.png";
import { saveSkincareTrackerApi } from "../../services/skinTracker.service";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { blob } from "stream/consumers";
const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;

interface SkincareProduct {
  product_id: number;
  [key: string]: any;
}

interface SkincareTrackerComponentInterface {
  data: any;
  updateProduct: (productId: number, field: string, value: any) => void;
}

const SkincareTrackerComponent: React.FC<SkincareTrackerComponentInterface> = ({
  data,
  updateProduct,
}) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const [saving, setSaving] = useState(false);

  // const [products, setProducts] = useState(initialProducts);

  // const updateProduct = (productId: any, field: any, value: any) => {
  //   setProducts((prev) =>
  //     prev.map((product) =>
  //       product.id === productId ? { ...product, [field]: value } : product
  //     )
  //   );
  // };

  const handleSave = async () => {
    try {
      setSaving(true);

      const payload = {
        survey_id: data.survey_id,
        skincare_data: data.skincare_data.map((product: SkincareProduct) => ({
          category: product.category,
          category_id: product.category_id,
          product_id: product.product_id,
          name: product.name,
          brand: product.brand,
          start_date: product.start_date,
          expire_date: product.expire_date,
          status: product.status,
          rating: product.rating,
          buy_again: product.buy_again,
          note: product.note,
        })),
      };

      dispatch(
        saveSkincareTrackerApi({
          data: payload,
          finalCallback: () => {
            setSaving(false);
          },
          successCallback: (responseData?: any) => {
            console.log("Save response:", responseData);
          },
          failureCallback: () => {
            message.error("Failed to save skincare data");
          },
        })
      );

      await new Promise((resolve) => setTimeout(resolve, 1000));

    } catch (error) {
      console.error("Error saving data:", error);
      message.error("Failed to save skincare data");
    } finally {
      setSaving(false);
    }
  };

  const getStatusColor = (status: any) => {
    switch (status) {
      case "not-started":
        return "#faad14";
      case "in-progress":
        return "#1890ff";
      case "finished":
        return "#52c41a";
      default:
        return "#d9d9d9";
    }
  };

  const getStatusText = (status: any) => {
    switch (status) {
      case "not-started":
        return "Not Started";
      case "in-progress":
        return "In Progress";
      case "finished":
        return "Finished";
      default:
        return "Unknown";
    }
  };

  const getBuyAgainColor = (buyAgain: any) => {
    switch (buyAgain) {
      case "yes":
        return "#52c41a";
      case "no":
        return "#ff4d4f";
      case "not-sure":
        return "#faad14";
      default:
        return "#d9d9d9";
    }
  };

  const getBuyAgainText = (buyAgain: any) => {
    switch (buyAgain) {
      case "yes":
        return "Yes";
      case "no":
        return "No";
      case "not-sure":
        return "Not Sure";
      default:
        return "Unknown";
    }
  };

  const formatDateForDisplay = (dateString: any) => {
    if (!dateString) return null;
    return dayjs(dateString);
  };

    const profile = useAppSelector((state) => state.profile);
   const { first_name } = profile;

  return (
    <section className="store-section skincare-tracker-component">
      <div style={{ display: "flex", justifyContent: "space-between"}}>
        <h1 className="tracker-title store-card__title">
          {first_name}'s Personalized Skincare Tracker
        </h1>
        <Button
          className="btn-secondary cta-btn"
          onClick={handleSave}
          loading={saving}
          size="large"
        >
          Save Changes
        </Button>
      </div>
      <div className="table-wrapper">

      <div style={{ overflowX: "auto" }}>
        <ResponsiveTable>
          <Thead>
            <Tr>
              <Th>
               <div className="heading-wrapper">
                <span>Product Name</span> <img src={productName} alt="icon" />
                </div>
              </Th>
              <Th>
                <div className="heading-wrapper">
                <span>Start Date</span> <img src={startDate} alt="icon" />
                </div>
              </Th>
              <Th>
                <div className="heading-wrapper">
               <span>Expire Date</span> <img src={expireDate} alt="icon" /> 
               </div>
              </Th>
              <Th>
                 <div className="heading-wrapper">
                <span>  Status </span>
              <img src={status} alt="icon" />
              </div>
              </Th>
              <Th>
                 <div className="heading-wrapper">
                <span>Rating </span><img src={Rating} alt="icon" />
                </div>
              </Th>
              <Th>
                 <div className="heading-wrapper">
                <span>Buy Again </span>
                <img src={buyAgain} alt="icon" />
                </div>
              </Th>
              <Th>
                <div className="heading-wrapper">
                <span> Notes </span>
               <img src={notes} alt="icon" />
               </div>
              </Th>
            </Tr>
          </Thead>

          <Tbody className="tracker-table-body">
            {data?.skincare_data && data.skincare_data.length ? (
              data.skincare_data.map((product: SkincareProduct) => (
                <Tr key={product.product_id}>
                  <Td>
                    <div style={{ fontWeight: 600, color: "#6489b1" }}>
                      <p>{product.brand}</p>
                     <p style={{ fontWeight: 500, color: "#000", marginBlock: "3px" }}>
  {product.name}
</p>
                      {product.category && (
                        <div style={{ fontSize: 12, color: "#666" }}>{product.category}</div>
                      )}
                    </div>
                  </Td>
                  <Td>
                    {/* <DatePicker
                      value={formatDateForDisplay(product.start_date)}
                      onChange={(date) => updateProduct(product.product_id, "start_date", date)}
                      format="MM/DD/YY"
                    /> */}
                  <DatePicker
                    value={formatDateForDisplay(product.start_date)}
                    onChange={(date) =>
                      updateProduct(product.product_id, "start_date", date)
                    }
                    placeholder="Start Date"
                    style={{ minWidth: "120px" }}
                    format="MM/DD/YY"
                  />

                  </Td>
                  <Td>
                    {/* <DatePicker
                      value={formatDateForDisplay(product.expire_date)}
                      onChange={(date) => updateProduct(product.product_id, "expire_date", date)}
                      format="MM/DD/YY"
                    /> */}
                    <DatePicker
                    value={formatDateForDisplay(product.expire_date)}
                    onChange={(date) =>
                      updateProduct(product.product_id, "expire_date", date)
                    }
                    placeholder="Expire Date"
                    style={{ minWidth: "120px" }}
                    format="MM/DD/YY"
                  />
                  </Td>
                  <Td>
 
               <Select
                    value={product.status}
                    onChange={(value) =>
                      updateProduct(product.product_id, "status", value)
                    }
                    style={{ width: "100%" }}
                    placeholder="Select status"
                  >
                    <Option value="not-started">
                      <Tag color={getStatusColor("not-started")}>
                        Not Started
                      </Tag>
                    </Option>
                    <Option value="in-progress">
                      <Tag color={getStatusColor("in-progress")}>
                        In Progress
                      </Tag>
                    </Option>
                    <Option value="finished">
                      <Tag color={getStatusColor("finished")}>Finished</Tag>
                    </Option>
                  </Select>
                  </Td>
                  <Td>
                    <Rate
                    value={product.rating}
                    className="rating"

                    onChange={(value) =>
                      updateProduct(product.product_id, "rating", value)
                    }
                  style={{ fontSize: "18px", textAlign: "center", minWidth: "130px" }}
                  />
                  </Td>
                  <Td>
                                 <Select
                    value={product.buy_again}
                    onChange={(value) =>
                      updateProduct(product.product_id, "buy_again", value)
                    }
                    style={{ width: "100%" }}
                    placeholder="Buy again?"
                  >
                    <Option value="yes">
                      <Tag color={getBuyAgainColor("yes")}>Yes</Tag>
                    </Option>
                    <Option value="no">
                      <Tag color={getBuyAgainColor("no")}>No</Tag>
                    </Option>
                    <Option value="not-sure">
                      <Tag color={getBuyAgainColor("not-sure")}>Not Sure</Tag>
                    </Option>
                  </Select>


                  </Td>
                  <Td>
                        <TextArea
                    value={product.note}
                    onChange={(e) =>
                      updateProduct(product.product_id, "note", e.target.value)
                    }
                    placeholder="Add notes..."
                    rows={2}
                    style={{ resize: "none" }}
                  />
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={7} style={{ textAlign: "center", padding: 20 }}>
                  <Title level={4}>No skincare products found.</Title>
                  <p>Please add products to your skincare tracker.</p>
                </Td>
              </Tr>
            )}
          </Tbody>
        </ResponsiveTable>
      </div>
      </div>

      <div className="footer-cta">
        <Button
          className="btn-primary cta-btn"
          onClick={() => {
            navigate("/store/personal-journal");
            ReactGA.event({
              category: "Store",
              action: `Go to Holistic Care button clicked`,
              nonInteraction: true,
              transport: "xhr",
            });
          }}
        >
          Go to Progress Journal
        </Button>
      </div>
    </section>
  );
};

export default SkincareTrackerComponent;
